<mat-card class="filter settingHeader">
    <div class="name">
        Manage Supply
    </div>
    <div class="quickAction">
        <mat-form-field class="example-form-field" appearence="fill" >
            <mat-label>Search Items</mat-label>
            <input matInput type="text" >            
          </mat-form-field>
        <div class="">
            <button mat-flat-button color="primary" (click)="openCaseDetail()" > Make Order </button>
        </div>
    </div>
</mat-card>

<div class="listingHolder">
    <table class="table">
        <tr>
            <th>Name</th>
            <th>Last Month</th>
            <th>Usage This Month</th>            
            <th>Bought This Month</th>
            <th>Current</th>
            <th>Vendor</th>
            <th>Comments</th>
            <th class="action" >Action</th>
        </tr>
        <tr>
            <td>Patient Oxygen Mask</td>
            <td>250 </td>
            <td>110</td>
            <td>50</td>
            <td>250</td>
            <td><a href="">A.M Suppliers</a></td>
            <td>Mask available only for surgery</td>
            <td>
                <div class="btnAction">
                    <button mat-icon-button color="primary"  >
                        <mat-icon>add_shopping_cart</mat-icon>
                    </button>
                </div>
            </td>
        </tr>
    </table>
</div>

<app-add-supply [ngClass]="{'open': showCaseDetail}"  (closeCaseDetail)=getCloseCaseDetail($event)  ></app-add-supply>